module.exports = __webpack_public_path__ + "img/mod-13.aabbea5c.svg";